import React from 'react';
import styled from 'styled-components';

import GIButton, { GIButtonProps } from '../../../../components/common/button/GIButton';

const StyledCardContainer = styled.div`
    button {
        border: none !important;
        text-transform: none !important;
        background: transparent !important;
        color: ${({ theme }) => theme.primaryMain};
        font-weight: bold !important;
        padding: 0px !important;
    }

    .gi-button__primary:hover,
    .gi-button__primary:focus {
        color: ${({ theme }) => theme.primaryMain};
    }
`;

const LinkButtons = ({ id, labelId, variant, size, icon, iconPlacement, onClickHandler }: GIButtonProps) => {
    return (
        <StyledCardContainer>
            <GIButton
                id={id}
                labelId={labelId}
                variant={variant}
                icon={icon}
                iconPlacement={iconPlacement}
                onClickHandler={onClickHandler}
            />
        </StyledCardContainer>
    );
};

export default LinkButtons;
